module.exports = __webpack_public_path__ + "assets/Track-Play.293f1f93.svg";